
import { message, notification } from "antd";

//types:- success,error,info

export const showNotification = (type, message) => {
  notification[type]({
    message: message,
    placement: "topRight",
    duration: 3,
  });
};

export const showMessage = (type, content) => {
  message[type]({
    content: content,
    duration: 3,
  });
};

export default Notification;
